import ApiService from "@/services/api.service"

/// *** CRM Service *** ///

export const CRMService = {
  getPlanTreatments(filters, lastId = null) {
    return ApiService.get(`crm/plan_treatments`, { filters, lastId })
  },
  getPatientCanban(filters, lastId = null, perPage = 100) {
    return ApiService.get(`crm/patient_canban`, { filters, lastId, perPage })
  },
  getPatientCanbanAuto(filters, lastId = null, perPage = 100) {
    return ApiService.get(`crm/patient_canban/auto`, { filters, lastId, perPage })
  },
  initiateSipuniCall(phone) {
    return ApiService.post(`sipuni/call/initiate`, { phone })
  },
  initiateUISCall(phone) {
    return ApiService.post(`uis/call/initiate`, { phone })
  },
  initiatePBXCall(phone) {
    return ApiService.post(`pbx/call/initiate`, { phone })
  },
  getStatuses() {
    return ApiService.get(`crm/statuses`)
  },
  getPatientCanbanStatuses(mode = 'manual') {
    return ApiService.get(`crm/patient_canban_statuses?mode=${mode}`)
  },
  bulkFunnelCreation(params) {
    return ApiService.post(`crm/funnel/bulk/create`, params)
  },
  createCanbanFromTask(params) {
    return ApiService.post(`crm/task/canban`, params)
  },
  createCanbanFromPatient(params) {
    return ApiService.post(`crm/patient/canban/generate`, params)
  },
  bulkLeadStatusChange(params) {
    return ApiService.post(`crm/lead/status/bulk`, params)
  },
  moveLeadsToCanban(params) {
    return ApiService.post(`crm/lead/move_to_canban`, params)
  },
  canbanStatusMoved(canbanId, params) {
    return ApiService.post(`crm/patient_canban/${canbanId}/moved`, params)
  },
  getAuraIframeUrl(phone = '') {
    return ApiService.post(`crm/aura/iframe/url?phone=${phone}`)
  },
  getMessengerChatId(phone = '', platform = '') {
    return ApiService.post(`crm/messenger/chatId`, { phone, platform })
  }
}
